import React from "react";
import MainImage from "../../assets/HeroImages/MainPot10.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";

function WebDesign() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>Custom Website Design for Women Entrepreneurs | Her Growth Co.</title>
      <meta
        name="description"
        content="Stand out with a website that converts. Our design services help women-led brands build authority, attract clients, and grow fast."
      />
      <meta
        name="keywords"
        content="high-end website design for women, expert web strategy for founders, feminine website makeovers, Austin web design agency, intentional branding for coaches, responsive design for women entrepreneurs, UX/UI for purpose-driven brands, digital presence for women CEOs"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold">Web Design Packages</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                Choose Your Path to Online Success
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                Our tiered service packages are designed to meet you where you are — whether you're starting fresh, building visibility, or ready to dominate.
              </p>
            </div>

            {/* Core Service Packages Section */}
            <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-3 md:gap-6">
              {/* Starter Package */}
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                <h3 className="text-xl font-semibold text-black text-center">Starter Package</h3>
                <p className="text-black text-lg font-light text-center">
                  Perfect for new businesses or those wanting an expert review.
                </p>
                <ul className="text-black text-base font-light list-disc list-inside mt-4">
                  <li>Basic 1-3 Page Website Design (WordPress or Squarespace)</li>
                  <li>Mobile responsiveness setup</li>
                  <li>Speed & UX/UI best practices</li>
                  <li>Mini SEO audit + keyword research</li>
                  <li>Homepage copy guidance</li>
                </ul>
              </div>

              {/* Growth Package */}
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                <h3 className="text-xl font-semibold text-black text-center">Growth Package</h3>
                <p className="text-black text-lg font-light text-center">
                  Ideal for those who want a solid SEO foundation + local growth.
                </p>
                <ul className="text-black text-base font-light list-disc list-inside mt-4">
                  <li>Up to 6 custom-designed pages</li>
                  <li>Full local SEO setup (Google Business Profile, citations)</li>
                  <li>Service page copy strategy & SEO</li>
                  <li>Keyword research + on-page SEO implementation</li>
                  <li>One month of SEO reporting & tracking</li>
                </ul>
              </div>

              {/* Premium Package */}
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                <h3 className="text-xl font-semibold text-black text-center">Premium Package</h3>
                <p className="text-black text-lg font-light text-center">
                  For ambitious entrepreneurs ready to dominate their niche.
                </p>
                <ul className="text-black text-base font-light list-disc list-inside mt-4">
                  <li>Custom website (up to 10+ pages) + blog setup</li>
                  <li>Advanced SEO (technical + local + authority building)</li>
                  <li>Content plan for 3 months</li>
                  <li>Email opt-in setup + lead magnet integration</li>
                  <li>Performance reporting + 3 months of support</li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                START A PROJECT →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                No ideas needed! We will talk though some of your inspirations.
              </p>
            </div>
          </div>
        </section>
        <PastWork/>
        <Footer />
      </section>
    </main>
  );
}


export default WebDesign